export default __webpack_public_path__ + "static/media/RefreshSVG.2b443f2f.svg";